/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense } from 'react';
import {
  Route,
  Switch,
  BrowserRouter as Router,
  Redirect,
} from 'react-router-dom';
import { Spin } from 'antd';
import { noSidebarRoute, sidebarRoutes } from './route';
import { AuthService } from '../services';
import URL from '../configs/baseUrl';
import { PageWrapper } from '../components';
// import ReactGA from 'react-ga';

const PrivateRoute = ({ component: Component, exact, path, ...rest }) => {
  return (
    <Route
      {...rest}
      render={() => {
        if (AuthService.isUserAuthenticated()) {
          return <Component />;
        }
        return <Redirect to={URL.LOGIN} />;
      }}
      exact={exact}
    />
  );
};

const SidebarRoute = () => {
  if (!AuthService.isUserAuthenticated()) {
    return (
      <Route
        render={() => {
          return <Redirect to={URL.LOGIN} />;
        }}
      />
    );
  }

  const filteredRoutes = sidebarRoutes.filter((item) => {
    return item?.isHasAccess;
  });

  return (
    <PageWrapper>
      <Suspense fallback={<Spin />}>
        <Switch>
          {filteredRoutes.map((route) => {
            return (
              <Route
                path={route.path}
                component={route.component}
                key={route.path}
              />
            );
          })}
        </Switch>
      </Suspense>
    </PageWrapper>
  );
};

const App = () => {
  return (
    <Router>
      <Suspense fallback={<Spin />}>
        <Switch>
          {noSidebarRoute.map((route) => {
            if (route.path !== URL.LANDING) {
              if (route.isPublic) {
                return (
                  <Route
                    path={route.path}
                    component={route.component}
                    key={route.path}
                  />
                );
              }
              return (
                <PrivateRoute
                  path={route.path}
                  component={route.component}
                  key={route.path}
                  exact={route.path === URL.LANDING}
                />
              );
            }
            return (
              <Route
                path={route.path}
                component={SidebarRoute}
                key={route.path}
              />
            );
          })}
        </Switch>
      </Suspense>
    </Router>
  );
};

export default App;
